<template>
  <div class="searchBar relative select-none" ref="searchBar">
    <transition name="fade">
      <div v-if="isMask" class="searchMask"></div>
    </transition>
    <div class="searchBar__search bg-white rounded-sm" :class="{'container': isDesktop}" v-click-outside="clickOutsideConfig">
      <div class="searchBar__search__left">
        <template v-if="isDesktop">
          <searchPlaceInput ref="searchPlaceInput" style="min-width: 300px;"/>
          <searchDatePicker ref="searchDatePicker" class="lg:block" style="min-width: 250px;" :isBlock="isTablet"/>
          <searchPeoplePicker ref="searchPeoplePicker" class="lg:block" style="min-width: 220px;" />
        </template>
        <template v-else>
          <div class="searchBar__search__left--mobile" @click.stop="clickIntercept">
            <i class="text-2xl owl-search" style="margin: 6px 8px 6px 0;"></i>
            <div style="pointer-events: none;">
              <searchPlaceInput ref="searchPlaceInput" />
              <div class="searchWrapForMobile">
                <searchDatePicker ref="searchDatePicker" class="lg:block" style="min-width: 250px;" :isBlock="isTablet" />
                <searchPeoplePicker ref="searchPeoplePicker" class="lg:block" style="min-width: 220px;" />
              </div>
            </div>
          </div>
        </template>
      </div>
      <button class="btn btn-solid btn-blue-light py-12 rounded-full hidden lg:block focus:bg-blue" style="min-width: 110px; max-width: 120px;" @click.stop="submitSearchData">{{ $t('search') }}</button>
      <!-- <button v-if="$route.name !== 'HotelDetail'" class="filterButton lg:border-l lg:ml-16 pl-16 flex flex-col items-center focus:outline-none" :class="{'activated': queryFiltersCount > 0}" style="min-width: 110px; max-width: 180px;" @click.stop="onToggleFilter">
        <div class="text-xl text-grey mb-4"><i class="owl-adjust"></i></div>
        <div class="text-xs text-grey-darkest">{{ $t('openSearchFilter') }} <span v-if="queryFiltersCount > 0">({{ queryFiltersCount  }})</span></div>
      </button> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
// import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mapGetters, mapMutations } from 'vuex'
import searchActions from '@/mixins/searchActions'

// import searchWarningModal from '@/components/modals/searchWarningModal'
export default {
  name: 'searchBar',
  data () {
    return {
      isMask: false,
      clickOutsideConfig: {
        handler: this.clickOutsideHandler,
        middleware: this.clickOutsideMiddleware
      }
    }
  },
  mixins: [
    searchActions
  ],
  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      isTablet: 'isTablet',
      isMobile: 'isMobile',
      isYokosoHotel: 'yokoso/isYokosoHotel',
      queryFilters: 'search/queryFilters',
      hotel: 'hotels/hotel'
    }),
    queryFiltersCount: function () {
      let count = 0
      const effectList = [
        'hotel_types',
        'features'
      ]
      _.each(this.queryFilters, function (item, key) {
        if (_.includes(effectList, key) && !_.isEmpty(item)) {
          count++
        }
      })
      return count
    }
  },
  methods: {
    ...mapMutations([
      'search/SET_SEARCH_BAR_STATUS'
    ]),
    clickOutsideMiddleware: function (event) {
      console.debug('Middleware', event)
      return true
    },
    clickOutsideHandler: function (event) {
      if (!this.clickOutsideMiddleware()) return
      console.debug('clickOutsideHandler', this.clickOutsideMiddleware(), event.target.classList)
      this.blurHandler()
    },
    blurHandler: function () {
      this.isMask = false
    },
    clickIntercept: function () {
      setTimeout(() => {
        this.$searchMobileModal.toggle(true)
      }, 300)
    },
    doValidate: async function () {
      let form = {}
      let errors = []
      await this.validateSearchPlaceInput().then(res => {
        form.search = res
      }).catch(err => {
        errors.push('searchPlaceInput')
        console.error(err)
        throw Error('searchPlaceInput is not filled.')
      })
      await this.validateSearchDatePicker().then(res => {
        form.date = res
      }).catch(err => {
        errors.push('searchDatePicker')
        console.error(err)
        throw Error('searchDatePicker is not filled.')
      })
      await this.validateSearchPeoplePicker().then(res => {
        form.people = res
      }).catch(err => {
        errors.push('searchPeoplePicker')
        console.error(err)
        throw Error('searchPeoplePicker is not filled.')
      })

      // If all validations passed
      if (errors.length > 0) {
        const errMsg = []
        for (const err of errors) {
          errMsg.push(this.$t(err))
        }
        return Promise.reject(errMsg)
      } else {
        return form
      }
    },
    submitSearchData: function () {
      this.doValidate().then(res => {
        const form = res

        console.debug('[search data validation done]: ', form)
        this.blurHandler()
        this._onClickSearchButton(form)
      }).catch(err => {
        const errMsg = err
        console.debug('[search data validation failed]: ', errMsg)
        // this.$modal.show(searchWarningModal, {
        //   context: `請完整輸入${errMsg.join(this.$t('and'))}`
        // }, {
        //   width: 380,
        //   height: 200
        // })
      })
    },
    toggleDatePicker: function () {
      this.$refs.searchDatePicker.focusHandler()
      this.isDesktop ? this.isMask = true : this.$searchMobileModal.toggle(true)
    },
    validateSearchPlaceInput: function () {
      return this.$refs.searchPlaceInput.doValidate().then(res => {
        if (res) {
          return res
        }
      }, err => {
        this.isDesktop ? this.isMask = true : this.$searchMobileModal.toggle(true)
        return Promise.reject(err)
      })
    },
    validateSearchDatePicker: function () {
      if (this.$refs.searchDatePicker) {
        return this.$refs.searchDatePicker.doValidate().then(res => {
          if (res) {
            return res
          }
        }, err => {
          this.isDesktop ? this.isMask = true : this.$searchMobileModal.toggle(true)
          return Promise.reject(err)
        })
      }
    },
    validateSearchPeoplePicker: function () {
      if (this.$refs.searchPeoplePicker) {
        return this.$refs.searchPeoplePicker.doValidate().then(res => {
          if (res) {
            return res
          }
        }, err => {
          this.isDesktop ? this.isMask = true : this.$searchMobileModal.toggle(true)
          return Promise.reject(err)
        })
      }
    },
    onToggleFilter: function () {
      this.doValidate().then(res => {
        this.$sidebar.toggle()
        this.$sidebar.set()
      }).catch(err => {
        // const errMsg = err
        console.debug(err)
        // this.$modal.show(searchWarningModal, {
        //   context: `請先輸入${errMsg.join(this.$t('and'))}`
        // }, {
        //   width: 380,
        //   height: 200
        // })
      })
    }
  },
  created () {
    Vue.prototype.$searchBar = this
  },
  mounted () {
    this['search/SET_SEARCH_BAR_STATUS'](true)
  }
}
</script>

<style lang="sass" scoped>
.searchBar
  @apply shadow
  @screen lg
    @apply px-16
  &__search
    @apply flex flex-row items-center justify-between
    @apply relative
    @apply px-16 py-8
    z-index: 2
    @screen lg
      @apply px-16 py-4 mx-auto
    &__left
      @apply flex items-center flex-col
      @apply w-full
      &--mobile
        @apply flex items-center overflow-hidden rounded-full
        @apply bg-grey-lightest p-8 text-xs font-bold
        ::v-deep .search-place
          @apply text-base mb-4
        .searchWrapForMobile
          @apply flex items-center
          & > div
            min-width: auto !important
        & > div
          &:nth-child(1)
            @apply text-base mb-4
      @screen lg
        @apply flex-row justify-between
        @apply w-auto
      & > div
        & > div, & > div > div
          @apply cursor-pointer
          box-shadow: none !important
        // @apply mx-8 mb-16
        @apply w-full
        @screen lg
          @apply mx-0 mb-0
    & > div, & button
      @apply flex-1
      @screen lg
        @apply w-auto
  .filterButton
    div
      @apply ease
    &.activated div, &:hover div
      @apply text-blue #{!important}
.searchMask
  @apply pin-t pin-l p-0 m-0
  @apply fixed
  background-color: black
  background-color: rgba(0, 0, 0, .4)
  width: calc(100vw - (100vw - 100%))
  height: 100vh
  z-index: 2
.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to, .fade-leave-active
  opacity: 0
</style>
